module.exports = "quill-editor.form-control {\n  height: auto;\n  padding-bottom: 0; }\n  quill-editor.form-control p {\n    margin-bottom: 1rem; }\n  quill-editor.form-control .ql-video {\n    width: 600px;\n    height: 300px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/book/book-send/second-step/mail-details.component.scss
// module id = ./src/app/book/book-send/second-step/mail-details.component.scss
// module chunks = main